

import {
    SessionManager,
    LoggerUtility
} from '../components/ComponentsLibrary';



class SessionService {
  constructor(sessionKey = SessionManager.LoginUserInfoKey) {
      // Load the user object from session storage on initialization
      this.sessionKey = sessionKey; // Custom session key
      const user = SessionManager.GetValueFromSession(this.sessionKey);
      this.LoginUserInfo = user ? JSON.parse(user) : null;
  };

  getUser() {
    try {
      return this.LoginUserInfo;
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "SessionService - getUser", {});
    }
  }

  setUser(userInfo) {
    try {
      if (userInfo && typeof userInfo === 'object') {
        this.LoginUserInfo = userInfo;
        sessionStorage.setItem(this.sessionKey, JSON.stringify(userInfo));
      }
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "SessionService - setUser", {});
    }
  }

  updateUser(updatedFields) {
    try {
      if (this.LoginUserInfo) {
        this.LoginUserInfo = { ...this.LoginUserInfo, ...updatedFields };
        sessionStorage.setItem(this.sessionKey, JSON.stringify(this.LoginUserInfo));
      }
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "SessionService - updateUser", {});
    }
  }

  clearUser() {
    try {
      this.LoginUserInfo = null;
      sessionStorage.removeItem(this.sessionKey);
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "SessionService - clearUser", {});
    }
  }

  getLegacyUserID() {
    try {
      return this.LoginUserInfo ? this.LoginUserInfo.legacyUserID : 15; // To-Do: Modify code - To disable default legacy userid  
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "SessionService - getLegacyUserID", {});
    }
  }
}

  
  // Export a single instance of the service
  const sessionService = new SessionService();
  export default sessionService;